import styled from "styled-components";

export const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const LogsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  padding-block-start: 24px;
  max-width: 1400px;
  margin: 0;
`;

export const TabsContainer = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 25px;
  margin: 0;
`;